import { ABTesting } from '../../frameworks_drivers/redux/reducers/abTest/abTesting';
import { MiscStoreData } from '../../frameworks_drivers/redux/reducers/miscellaneous/miscSlice';
import { PayloadBuilder } from '../../utils/PayloadBuilder';
import { IAcquisitionRepository } from '../../application/ports/repositories/IAcquisitionRepository';

export class AcquisitionService {
  private repository: IAcquisitionRepository;

  constructor(repository: IAcquisitionRepository) {
    this.repository = repository;
  }

  async createOrder(storeData: any, abTestng: ABTesting, miscData: MiscStoreData): Promise<any> {
    return this.repository.createOrder(this.buildPayload(storeData, abTestng, miscData));
  }

  async createLead(storeData: any, abTestng: ABTesting, miscData: MiscStoreData): Promise<any> {
    return this.repository.createLead(this.buildPayload(storeData, abTestng, miscData));
  }

  async getLeadById(leadId: string, readKey: string): Promise<any> {
    return this.repository.getLeadById(leadId, readKey);
  }

  async convertLeadToOrder(
    leadId: string,
    confirmationKey: string,
    dataProcessingAgreementVersion: string
  ): Promise<any> {
    return this.repository.convertLeadToOrder(
      leadId,
      confirmationKey,
      dataProcessingAgreementVersion
    );
  }

  private buildPayload(storeData: any, abTesting: ABTesting, miscData: MiscStoreData) {
    return PayloadBuilder.buildPayloadFromStoreData(storeData, abTesting, miscData);
  }
}
